import React, { FC, ReactElement } from 'react';
import { useCommon } from 'src/AppState/Common';
import { GENERAL_DETAILS_ROOT } from 'src/domains/casino/utils/test-variables';
import { BonusCreationState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation.state';
import { Input } from 'src/domains/common/components/input/input';
import { Textarea } from 'src/domains/layouts/shared/formComponents/textarea/Textarea';
import { observer } from 'src/utils/mobx-react';

type GeneralDetailsPropsType = {
    bonusCreationId?: string;
};

export const GeneralDetails: FC<GeneralDetailsPropsType> = observer(
    'GeneralDetails',
    (props: GeneralDetailsPropsType): ReactElement => {
        const common = useCommon();
        const { generalDetailsState, editionDisabled } = BonusCreationState.get(common, props.bonusCreationId);

        return (
            <div
                className='grid grid-cols-2'
                data-test={GENERAL_DETAILS_ROOT}
            >
                <section
                    data-test='basic-info'
                    className='flex flex-col gap-6'
                >
                    <h2 className='m-0 text-[1rem] font-semibold leading-[1.75]'>Basic Information</h2>
                    <div className='flex flex-col gap-4'>
                        <Input
                            label='Bonus Name'
                            placeholder='Type'
                            formInputState={generalDetailsState.nameForm}
                            errors={generalDetailsState.nameForm.errorsForView}
                            disabled={editionDisabled}
                        />
                        <div className='flex flex-col gap-2'>
                            <label className='text-sm'>Terms & Conditions</label>
                            <Textarea
                                formState={generalDetailsState.termsAndConditionsForm}
                                ckeditor
                                isReadOnly={editionDisabled}
                                customErrorMessage={
                                    generalDetailsState.termsAndConditionsForm.errorsForView.length > 0 ? (
                                        <span className='text-sm text-destructive mt-2'>
                                            {generalDetailsState.termsAndConditionsForm.errorsForView[0]}
                                        </span>
                                    ) : undefined
                                }
                            />
                        </div>
                    </div>
                </section>
            </div>
        );
    }
);
